import { OverlayModal } from "goi_common";
import { Box } from "@chakra-ui/react";
import { css } from "@emotion/react";
import { useOverlay } from "@toss/use-overlay";
import {
  HStack,
  colors,
  customEvent,
  getCdnImageSrc,
  Image,
  useResponsive,
  call,
} from "goi_common";
import { ReactNode } from "react";
import FlowerModalContent from "@/containers/Parlor/ParlorDetailContainer/components/Modal/FlowerModalContent";

export default function ParlorCallButtons({
  companyName,
  parlorId,
}: {
  companyName: string;
  parlorId: number;
}) {
  const overlay = useOverlay();
  const { isBiggerThanLg } = useResponsive();
  const onFlowerClick = () => {
    overlay.open(({ isOpen, close: onClose }) => {
      return (
        <OverlayModal
          onClose={onClose}
          isOpen={isOpen}
          closeOnOverlayClick={true}
          modalContentStyle={{
            minWidth: "340px",
            minHeight: isBiggerThanLg ? "" : "90vh",
          }}
          overlayModalContent={
            <FlowerModalContent parlorId={parlorId} companyName={companyName} onClose={onClose} />
          }
          header={{
            content: <FlowerModalContent.header onClose={onClose} />,
          }}
        />
      );
    });
  };

  const onDiscountClick = () => {
    call("1666-9784");
  };
  const onFuneralClick = () => {
    call("1666-9784");
  };
  return (
    <HStack
      as="ul"
      justifyContent="space-between"
      width="100%"
      padding="16px 0px 0px 0px"
      gap="8px"
    >
      <BadgeIcon
        onClick={() => {
          onFuneralClick();
          customEvent({
            newGtm: {
              path: "parlor_detail_price",
              trigger_and_target: "call-sangjo_service",
              text: companyName,
            },
          });
        }}
        icon={
          <Image width="30px" alt="services" src={getCdnImageSrc("platform/parlor/service.png")} />
        }
        title={
          <>
            <b>상조서비스</b>
            <br />
            이용문의
          </>
        }
      />
      <BadgeIcon
        onClick={() => {
          onDiscountClick();
          customEvent({
            newGtm: {
              path: "parlor_detail_price",
              trigger_and_target: "call-binso_discount",
              text: companyName,
            },
          });
        }}
        icon={
          <Image
            width="60px"
            alt="binso-discount"
            src={getCdnImageSrc("platform/parlor/binso-discount.png")}
          />
        }
        title={
          <>
            <b>빈소 할인 📞</b>
            <br />
            문의
          </>
        }
      />
      <BadgeIcon
        onClick={() => {
          onFlowerClick();
          customEvent({
            newGtm: {
              path: "parlor_detail_price",
              trigger_and_target: "call-hwahwan_bonaegi",
              text: companyName,
            },
          });
        }}
        icon={<Image width="60px" alt="화환" src={getCdnImageSrc("platform/parlor/flowers.png")} />}
        title={
          <>
            <b>화환 🌸</b>
            <br />
            보내기
          </>
        }
      />
    </HStack>
  );
}

const BadgeIcon = ({
  icon,
  title,
  onClick,
}: {
  icon: ReactNode;
  title: ReactNode;
  onClick: () => void;
}) => {
  return (
    <Box borderRadius="6px" border={`1px solid ${colors.gray300}`} width="100%">
      <HStack
        onClick={onClick}
        alignItems="center"
        justifyContent="space-between"
        padding="6px 2px"
        gap="6px"
        css={css`
          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
        `}
      >
        <Box
          as="li"
          textAlign="center"
          whiteSpace="pre"
          margin="auto"
          className="body_14_m gray700"
        >
          {title}
        </Box>
      </HStack>
    </Box>
  );
};
